module.exports = __webpack_public_path__ + "videos/hero_cn.9699728.mp4";